var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"announcement"},[_c('div',{staticClass:"cont",style:({ height: _vm.height })},[_c('div',{ref:"contlist",staticClass:"contlist",on:{"mouseover":_vm.stopScroll,"mouseout":_vm.startScroll}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }